export default "/Frontend/dist/doc-black.57d856e878b287b2686bd3112352b5fe.svg";